import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import formatPrice from '../../helpers/formatPrice';
import getFeesInfos from '../../helpers/getFeesInfos';
import getAccommodationsInfos from '../../helpers/getAccommodationsInfos';
import { changeAccommodations, changeCourses, changeFees } from '../../redux/quoteSlice';
import getCoursesInfos from '../../helpers/getCoursesInfos';
import Discount from '../Discount/Discount';
import CoursesInfo from './CoursesInfo/CoursesInfo';
import AccommodationInfo from './AccommodationInfo/AccommodationInfo';
import FeeInfo from './FeeInfo/FeeInfo';

const MySwal = withReactContent(Swal);

const { pathname } = window.location;
const paths = pathname.split('/');
const linktype = paths[3];

function Observations() {
  const dispatch = useDispatch();
  const reduxState = useSelector((state) => state);
  const {
    quote: {
      otherFees,
      payment: {
        value,
        valueWithoutSr,
        convertedValue,
        convertedValueWithoutSr,
        currencyInfo: { code },
      },
      courses,
      fees,
      accommodations,
      hash,
      country,
      accountId,
    },
    accommodations: accommodationPriceHash,
    fees: feePriceHash,
    courses: coursePriceHash,
    payments: { totalDiscountPercentage, consultingFeeInReais, iofFeeInReais },
  } = reduxState;

  const requestFees = (rawFees) => {
    rawFees.forEach(({
      periodId, quoteId, ...fee
    }) => {
      const params = {
        ...fee,
        period_id: periodId,
        quote_id: quoteId,
        account_id: accountId,
        country,
        hash,
      };

      getFeesInfos(params).then((info) => dispatch(changeFees(info)));
    });
  };

  const requestAccommodations = (rawAccommodations) => {
    rawAccommodations.forEach(({
      quoteId, periodId, ...accommodation
    }) => {
      const params = {
        ...accommodation,
        period_id: periodId,
        quote_id: quoteId,
        account_id: accountId,
        country,
        hash,
      };

      getAccommodationsInfos(params).then((info) => dispatch(changeAccommodations(info)));
    });
  };

  const requestCourses = (rawCourses) => {
    rawCourses.forEach(({
      id,
      duration,
      periodId,
      quoteId,
      enrolActive,
      materialActive,
      srcourseId,
      srenrolId,
      srmaterialId,
      srperiodId,
      srperiodActive,
      srcourseActive,
      srenrolActive,
      srmaterialActive,
    }) => {
      const srReject = [];
      if (srperiodId > 0 && srperiodActive === 0) {
        srReject.push(srperiodId);
      }
      if (srcourseId > 0 && srcourseActive === 0) {
        srReject.push(srcourseId);
      }
      if (srenrolId > 0 && srenrolActive === 0) {
        srReject.push(srenrolId);
      }
      if (srmaterialId > 0 && srmaterialActive === 0) {
        srReject.push(srmaterialId);
      }

      const params = {
        id,
        duration,
        period_id: periodId,
        quote_id: quoteId,
        enrolActive,
        srperiod_id: srperiodId,
        srcourse_id: srcourseId,
        srenrol_id: srenrolId,
        srmaterial_id: srmaterialId,
        materialActive,
        srReject: JSON.stringify(srReject),
        account_id: accountId,
        country,
        hash,
      };

      getCoursesInfos(params).then((info) => dispatch(changeCourses(info)));
    });
  };

  useEffect(() => {
    requestFees(fees);
    requestAccommodations(accommodations);
    requestCourses(courses);

    if (coursePriceHash.length || accommodationPriceHash.length || feePriceHash.length) {
      const itensBase = courses.length + accommodations.length + fees.length;
      // eslint-disable-next-line max-len
      const itensView = coursePriceHash.length + accommodationPriceHash.length + feePriceHash.length;
      if (itensBase === itensView) {
        console.log(fees);
        console.log(feePriceHash);
        let totalBase = reduxState.quote.payment.value;
        let totalView = 0;
        if (reduxState.quote.payment.totalValues) {
          if (reduxState.quote.payment.totalValues.length > 1) {
            totalBase = 0;
            reduxState.quote.payment.totalValues.forEach((element) => {
              totalBase += element.value;
            });
          }
        }
        reduxState.quote.otherFees.forEach((element) => {
          totalView += element.totalValue;
        });
        coursePriceHash.forEach((element) => {
          totalView += element.totalValue;
        });
        feePriceHash.forEach((element) => {
          totalView += element.totalValue;
        });
        accommodationPriceHash.forEach((element) => {
          totalView += element.totalValue;
        });
        if (totalBase !== totalView) {
          MySwal.fire({
            icon: 'error',
            title: 'Orçamento vencido',
            text: 'Por favor, entre em contato com o consultor para ajustá-lo!',
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.replace(
                'https://ieintercambio.allyhub.co/',
              );
            }
          });
        }
      }
    }
  }, [coursePriceHash, accommodationPriceHash, feePriceHash]);

  const iof = Number(iofFeeInReais || 0);

  const totalDeValue = linktype === '2'
    ? Number(convertedValueWithoutSr || 0) - Number(consultingFeeInReais || 0)
    : Number(convertedValueWithoutSr || 0);

  const porValue = linktype === '2'
    ? Number(convertedValue || 0) - Number(consultingFeeInReais || 0) - iof
    : Number(convertedValue || 0) - iof;

  const finalTotalValue = linktype === '2'
    ? Number(convertedValue || 0) - Number(consultingFeeInReais || 0)
    : Number(convertedValue || 0);

  return (
    <section className="py-3 info-table-row ">
      { courses.length > 0 && <CoursesInfo courses={coursePriceHash} currency={code} /> }

      {
        accommodations.length > 0
          && <AccommodationInfo accommodations={accommodationPriceHash} currency={code} />
      }

      {
        (fees.length > 0 || otherFees.length > 0)
          && <FeeInfo fees={[...feePriceHash, ...otherFees]} currency={code} />
      }

      {linktype !== '2' && (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {
          totalDiscountPercentage > 0
            ? (
              <h6>
                {'Total de '}
                <span className="text-decoration-line-through">{`${formatPrice(valueWithoutSr, code)}`}</span>
                {` por ${formatPrice(value, code)}`}
              </h6>
            )
            : (
              <h6>
                {`Total: ${formatPrice(value, code)}`}
              </h6>
            )
        }
        </>
      )}

      <div className={`d-flex justify-content-between flex-wrap ${totalDiscountPercentage > 0 ? '' : 'flex-row-reverse'}`}>
        <Discount type />

        <div className="d-flex justify-content-evenly flex-column">
          {totalDiscountPercentage > 0 && (
            <p className="my-0 text-right">
              <span className="text-muted small">{'Total: de '}</span>
              <span className="text-decoration-line-through text-danger">
                {formatPrice(totalDeValue)}
              </span>
            </p>
          )}
          <p className="my-0 text-right strong">
            <span>{'Por: '}</span>
            {formatPrice(porValue)}
          </p>
          <p className="my-0 text-right">
            {`+ IOF ${formatPrice(iof)}`}
          </p>
          <p className="my-0 blue payment text-right strong">
            <span>{'Total: '}</span>
            {formatPrice(finalTotalValue)}
          </p>
        </div>

      </div>
    </section>
  );
}

export default Observations;
